import React from 'react';
import { FDDisplayText } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const IMAGE_BG_URL = 'https://static.facetwealth.com/app/image/login/login-right-half-bg-no-text.jpg';

const useStyles = buildUseStyles('CoverImage', (theme) => ({
  root: {
    position: 'relative',
    flex: '1 0 0',
    height: '100%',
    width: 0,
    backgroundSize: 'cover',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${IMAGE_BG_URL})`,
    backgroundPosition: 'center',
  },
  imageSloganContainer: {
    maxWidth: 600,
    position: 'absolute',
    left: theme.spacing(8),
    paddingRight: theme.spacing(8),
    top: '50%',
    transform: 'translateY(-50%)',
    // Facet design doesn't know that white is allowed on this background.
    // It thinks there's a white background behind it so it would prevent color="white" from taking effect for contrast reasons.
    // However, I know that the image this is on top of would contrast well with white, which is why I'm manually overriding it now to use white text
    '& > .FD-MuiTypography-root': {
      color: 'white',
    },
  },
}));

export const CoverImage = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.imageSloganContainer}>
        <FDDisplayText
          size="md"
          value="Financial planning as it should be"
        />
      </div>
    </div>
  );
};
